/** @jsxImportSource @emotion/react */
import { Button, notification, Skeleton } from "antd";
import { ReactComponent as DepositSvg } from "assets/Common/icons/Deposit.svg";
import { ReactComponent as TransferSvg } from "assets/Common/icons/icon-transfer.svg";
// import { ReactComponent as MemberDocumentIcon } from "assets/Common/icons/icon-member-documents.svg";
// import { ReactComponent as MemberVipIcon } from "assets/Common/icons/icon-member-vip.svg";
import { ReactComponent as ProfileActiveSvg } from "assets/Common/icons/profileActive.svg";
import { ReactComponent as WithdrawSvg } from "assets/Common/icons/withdraw.svg";
// import ReferralIcon from "assets/Desktop/icons/referral.png";
import { ReactComponent as BellIcon } from "assets/temporary/icons/bell.svg";
import { ReactComponent as BettingRecordIcon } from "assets/temporary/icons/betting-record.svg";
import { ReactComponent as HistoryIcon } from "assets/temporary/icons/history.svg";
import { ReactComponent as LogoutIcon } from "assets/temporary/icons/logout.svg";
import { ReactComponent as MissionIcon } from "assets/temporary/icons/mission.svg";
// import { ReactComponent as MemberReportIcon } from "assets/temporary/icons/member-report.svg";
import { ReactComponent as RefreshIcon } from "assets/temporary/icons/refresh.svg";
import { ReactComponent as SettingIcon } from "assets/temporary/icons/setting.svg";
import { PATH } from "contants/path";
import { formatNumberWithCommas } from "helpers/formatNumber";
import { canAccessTransfer } from "helpers/permissionAccess";
import { useAppSelector } from "hooks/app-hook";
import { useAppLogout } from "hooks/useAppLogout";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router";
import { selectUsername } from "store/auth";
import { selectDataFeature, selectLoadingFeature } from "store/feature";
import {
  selectBalance,
  selectBalanceLoading,
  selectProfile,
  selectProfileLoading,
} from "store/user";
import { getMemberBalance } from "store/user/user.thunk";
import { theme } from "styles/theme";
import { AppDispatch, StatusNotification } from "types";

import { useModalConfirm } from "../ModalConfirm";
import { UserMenuSidebarStyle } from "./style.index";

interface DataItemsMenuType {
  key: string;
  label: string;
  icon: React.ReactNode;
}
interface DataMenuType {
  data: DataItemsMenuType[];
  key: number;
}

const ICON_COLOR = theme.colors.darkGreen;

const dataMenu: DataMenuType[] = [
  {
    data: [
      {
        key: PATH.User.deposit,
        label: "Deposit",
        icon: (
          <DepositSvg
            fill="none"
            className="history-icon"
            stroke={ICON_COLOR}
          />
        ),
      },
      {
        key: PATH.User.withdraw,
        label: "Withdraw",
        icon: (
          <WithdrawSvg
            fill="none"
            className="history-icon"
            stroke={ICON_COLOR}
          />
        ),
      },
      {
        key: PATH.User.transfer,
        label: "Transfer",
        icon: (
          <TransferSvg
            fill="none"
            className="history-icon"
            color={ICON_COLOR}
          />
        ),
      },
      {
        key: PATH.User.TransactionHistory,
        label: "History",
        icon: <HistoryIcon className="history-icon" stroke={ICON_COLOR} />,
      },
    ],
    key: 1,
  },
  {
    data: [
      {
        key: PATH.User.personalDetails,
        label: "PersonalInformation",
        icon: <ProfileActiveSvg fill={ICON_COLOR} />,
      },
      {
        key: PATH.User.BettingRecord,
        label: "Betting History",
        icon: <BettingRecordIcon fill={ICON_COLOR} />,
      },
      {
        key: PATH.User.Referral,
        label: "Referral",
        icon: <BettingRecordIcon fill={ICON_COLOR} />,
      },
      {
        key: PATH.User.Announcement,
        label: "Messages",
        icon: <BellIcon fill={ICON_COLOR} />,
      },
      {
        key: PATH.User.Challenge,
        label: "Mission",
        icon: <MissionIcon width={19} height={19} fill={ICON_COLOR} />,
      },
      {
        key: PATH.User.Setting,
        label: "Setting",
        icon: <SettingIcon width={19} height={19} fill={ICON_COLOR} />,
      },
    ],
    key: 2,
  },
  // {
  //   title: "KYC Certificate",
  //   data: [
  //     {
  //       key: PATH.User.memberDocuments,
  //       label: "Upload",
  //       icon: <MemberDocumentIcon fill={theme.colors.darkGreen} />,
  //     },
  //   ],
  //   key: 3,
  // },
];

const UserMenuSidebar = () => {
  const dispatch = useDispatch<AppDispatch>();

  const { t } = useTranslation(["menuUser", "currency", "login"]);

  const { contextHolder: ContextConfirm, modalConfig } = useModalConfirm();
  const balance = useSelector(selectBalance);
  const isLoadingBalance = useAppSelector(selectBalanceLoading);
  const profile = useAppSelector(selectProfile);
  const isLoadingProfile = useAppSelector(selectProfileLoading);

  const { pathname } = useLocation();
  const navigate = useNavigate();
  const onLogout = useAppLogout();
  const _username =
    useSelector(selectUsername) || localStorage.getItem("username") || "";
  const toggleFeature = useAppSelector(selectDataFeature);
  const isLoadingFeature = useAppSelector(selectLoadingFeature);

  // const dataEmptyBalance = _isEqual(initialState.balance, balance);

  const username = useAppSelector(selectUsername);

  const [api, contextHolder] = notification.useNotification();

  const openNotification = (status: StatusNotification, message: string) => {
    api[status]({
      message,
      description: "",
    });
  };

  const handleSelected = (key: string) => {
    navigate(key);
  };

  const showConfirmLogout = () => {
    modalConfig({
      title: t("login:Logout"),
      onSuccess: () => {
        onLogout();
      },
    });
  };

  const renderMenu = dataMenu.map((item, index) => {
    return (
      <div key={`key-${index}-menu`}>
        {item.data.map((itemMenu: DataItemsMenuType) => {
          if (
            toggleFeature &&
            (itemMenu.label === "Deposit" || itemMenu.label === "Withdraw")
          ) {
            return;
          }
          if (!canAccessTransfer(username) && itemMenu.label === "Transfer") {
            return;
          }

          return isLoadingFeature ? (
            <div key={itemMenu.key} css={UserMenuSidebarStyle.menuItem(false)}>
              <Skeleton.Avatar size={"small"} />
              <Skeleton.Button className="loading" />
            </div>
          ) : (
            <div
              key={itemMenu.key}
              onClick={() => handleSelected(itemMenu.key)}
              css={UserMenuSidebarStyle.menuItem(itemMenu.key === pathname)}
            >
              {itemMenu.icon}
              <span css={UserMenuSidebarStyle.menuLabel} data-comp="menu-label">
                {t(itemMenu.label)}
              </span>
            </div>
          );
        })}
      </div>
    );
  });

  const handleRefreshBalance = async () => {
    try {
      await dispatch(getMemberBalance({ username: username }));
    } catch (error) {
      openNotification("error", "Please try again later!");
    }
  };

  return (
    <div css={UserMenuSidebarStyle.self}>
      <div css={UserMenuSidebarStyle.wallet}>
        <span css={UserMenuSidebarStyle.walletUsername}>
          {!isLoadingProfile && profile ? (
            profile?.username
          ) : (
            <Skeleton.Button size="small" style={{ width: 100 }} />
          )}
        </span>
        <div css={UserMenuSidebarStyle.list}>
          <span css={UserMenuSidebarStyle.walletValue}>
            <Skeleton
              loading={isLoadingBalance}
              style={{ height: "100%", width: "60px" }}
              title={isLoadingBalance}
              active={isLoadingBalance}
              paragraph={false}
            >
              <p>
                {t("currency:BDT")}{" "}
                {formatNumberWithCommas(balance?.total || "0.00")}
              </p>
            </Skeleton>
          </span>
          <div
            css={UserMenuSidebarStyle.balance(isLoadingBalance)}
            onClick={handleRefreshBalance}
          >
            <RefreshIcon height={18} width={18} />
          </div>
        </div>
        <div css={UserMenuSidebarStyle.list}>
          <span css={UserMenuSidebarStyle.walletValue}>
            <Skeleton
              loading={isLoadingBalance}
              style={{ height: "100%", width: "60px" }}
              title={isLoadingBalance}
              active={isLoadingBalance}
              paragraph={false}
            >
              <p>
                {t("placeholder:Coins")}:{" "}
                {formatNumberWithCommas(balance?.coins || "0.00")}
              </p>
            </Skeleton>
          </span>
          <div
            css={UserMenuSidebarStyle.balance(isLoadingBalance)}
            onClick={handleRefreshBalance}
          >
            <RefreshIcon height={18} width={18} />
          </div>
        </div>
      </div>
      {renderMenu}

      <div css={UserMenuSidebarStyle.buttonContainer}>
        <Button
          size="middle"
          type="primary"
          css={UserMenuSidebarStyle.btnLogout}
          icon={<LogoutIcon style={{ marginTop: "-2px" }} />}
          onClick={showConfirmLogout}
          block
        >
          {t("button:Logout")}
        </Button>
      </div>
      {contextHolder}
      {ContextConfirm}
    </div>
  );
};

export default UserMenuSidebar;
